export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const REDIRECT_TIMER_START = 'REDIRECT_TIMER_START';
export const REDIRECT_TIMER_FINISH = 'REDIRECT_TIMER_FINISH';
